import React, { useState } from "react";

function formatDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-GB", { day:"2-digit", month:"short", year:"numeric" });
}

function TerminateModal({ contractor, managerEmail, onClose, onSuccess }) {
  const [mode, setMode] = useState("immediate");
  const [terminateDate, setTerminateDate] = useState(new Date().toISOString().split("T")[0]);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [ticketNumber, setTicketNumber] = useState(null);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const response = await fetch('/api/raiseTicket', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'terminate',
          contractorEmail: contractor.email,
          contractorName: contractor.name,
          managerEmail: managerEmail,
          terminateMode: mode,
          terminateDate: terminateDate,
        })
      });
      if (!response.ok) throw new Error('Failed to raise ticket');
      const data = await response.json();
      setTicketNumber(data.ticketNumber);
      setSubmitted(true);
      setTimeout(() => onSuccess(), 1000);
      if (onSuccess) onSuccess(contractor.email, data.ticketNumber);
    } catch (err) {
      setSubmitError('Something went wrong raising the ticket. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const overlayStyle = { position:"fixed", inset:0, background:"rgba(24,7,58,0.4)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:100, backdropFilter:"blur(4px)" };
  const modalStyle = { background:"#fff", borderRadius:"10px", padding:"28px", width:"440px", boxShadow:"0 20px 60px rgba(24,7,58,0.2)" };
  const labelStyle = { fontSize:"10px", fontWeight:700, color:"#4d4777", marginBottom:"5px", textTransform:"uppercase", letterSpacing:"0.05em", display:"block" };
  const inputStyle = { width:"100%", padding:"9px 12px", border:"0.5px solid #e0e0df", borderRadius:"6px", fontSize:"12px", color:"#18073a", background:"#fff", fontFamily:"Montserrat, sans-serif" };
  const disabledInputStyle = { ...inputStyle, background:"#f5f5f3", color:"#b0adc8", borderColor:"transparent" };

  return (
    <div style={overlayStyle} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={modalStyle}>
        <div style={{ fontSize:"16px", fontWeight:700, color:"#18073a", marginBottom:"3px" }}>Terminate contract</div>
        <div style={{ fontSize:"12px", color:"#79749c", marginBottom:"22px" }}>{contractor.name} · {contractor.jobTitle}</div>

        {!submitted && (
          <div style={{ background:"#f5e8ea", borderLeft:"3px solid #82162d", borderRadius:"0 6px 6px 0", padding:"12px 14px", fontSize:"11px", color:"#82162d", marginBottom:"16px", lineHeight:1.7, fontWeight:500 }}>
            This will raise a leavers request with IT. The contractor's account and access will be removed. This cannot be undone.
          </div>
        )}

        <div style={{ marginBottom:"14px" }}>
          <label style={labelStyle}>Current end date</label>
          <input style={disabledInputStyle} value={contractor.endDate ? formatDate(contractor.endDate) : "No expiry set"} disabled />
        </div>

        {!submitted && (
          <>
            <div style={{ marginBottom:"14px" }}>
              <label style={labelStyle}>Termination date</label>
              <div style={{ display:"flex", gap:"6px", marginBottom:"10px" }}>
                <button
                  onClick={() => setMode("immediate")}
                  style={{ flex:1, padding:"8px", borderRadius:"6px", fontSize:"12px", fontWeight:600, cursor:"pointer", fontFamily:"Montserrat, sans-serif", border:"0.5px solid", borderColor: mode==="immediate" ? "#18073a" : "#e0e0df", background: mode==="immediate" ? "#18073a" : "#fff", color: mode==="immediate" ? "#fff" : "#79749c" }}
                >
                  Immediate
                </button>
                <button
                  onClick={() => setMode("scheduled")}
                  style={{ flex:1, padding:"8px", borderRadius:"6px", fontSize:"12px", fontWeight:600, cursor:"pointer", fontFamily:"Montserrat, sans-serif", border:"0.5px solid", borderColor: mode==="scheduled" ? "#18073a" : "#e0e0df", background: mode==="scheduled" ? "#18073a" : "#fff", color: mode==="scheduled" ? "#fff" : "#79749c" }}
                >
                  Scheduled
                </button>
              </div>
              {mode === "scheduled" && (
                <input
                  style={inputStyle}
                  type="date"
                  value={terminateDate}
                  min={new Date().toISOString().split("T")[0]}
                  onChange={e => setTerminateDate(e.target.value)}
                />
              )}
              {mode === "scheduled" && (
                <div style={{ fontSize:"11px", color:"#79749c", marginTop:"5px" }}>
                  Account will be disabled at 5:00 PM on the selected date.
                </div>
              )}
            </div>
          </>
        )}

        {submitError && (
          <div style={{ fontSize:"11px", color:"#82162d", marginBottom:"8px", fontWeight:500 }}>{submitError}</div>
        )}

        {submitted ? (
          <div style={{ marginTop:"4px" }}>
            <div style={{ background:"#e8ede7", borderLeft:"3px solid #677a64", borderRadius:"0 6px 6px 0", padding:"11px 13px", fontSize:"12px", color:"#3a4838", marginBottom:"16px" }}>
              Leavers request submitted successfully. {ticketNumber && `Ticket ${ticketNumber} has been raised.`}
            </div>
            <div style={{ display:"flex", justifyContent:"flex-end" }}>
              <button onClick={onClose} style={{ padding:"9px 16px", fontSize:"12px", fontWeight:600, color:"#79749c", background:"#f0f0ef", border:"none", borderRadius:"6px", cursor:"pointer", fontFamily:"Montserrat, sans-serif" }}>Close</button>
            </div>
          </div>
        ) : (
          <div style={{ display:"flex", gap:"8px", justifyContent:"flex-end" }}>
            <button onClick={onClose} style={{ padding:"9px 16px", fontSize:"12px", fontWeight:600, color:"#79749c", background:"#f0f0ef", border:"none", borderRadius:"6px", cursor:"pointer", fontFamily:"Montserrat, sans-serif" }}>Cancel</button>
            <button onClick={handleSubmit} disabled={submitting} style={{ padding:"9px 20px", fontSize:"12px", fontWeight:700, background: submitting ? "#b0adc8" : "#82162d", color:"#fff", border:"none", borderRadius:"6px", cursor: submitting ? "not-allowed" : "pointer", fontFamily:"Montserrat, sans-serif" }}>
              {submitting ? "Submitting…" : "Confirm termination"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default TerminateModal;